export default __webpack_public_path__ + "static/media/bg-loading.d48b8f0b.jpg";